<template>
<div id="container">
  <div class="locationWrap policy">
    <div>
      <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
      <strong class="inner locTit aniBox type_bot gogo">
        <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>이메일주소무단수집거부
      </strong>
    </div>
  </div>
  <div class="contents">
    <div class="inner">
      <div class="subTitWrap aniBox type_left gogo">
        <h2>이메일주소무단수집거부</h2>
      </div>

      <div class="terms-box" style="height:auto;border:0">
        <div class="terms-conditions">
          본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반시 정보통신망법에 의해 형사처벌됨을 유념하시기 바랍니다.
        </div>
        <h1>정보통신망 이용촉진 및 정보보호 등에 관한 법률</h1>
        <div class="terms-conditions">
          [일부개정 2002.12.18 법률 제06797호]
        </div>
        <h2>제50조의2 (전자우편주소의 무단 수집행위 등 금지)</h2>
        <div class="terms-conditions">
          ① 누구든지 전자우편주소의 수집을 거부하는 의가사 명시된 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.<br>
          ② 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니된다.<br>
          ③ 누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보전송에 이용하여서는 아니된다.
        </div>
        <h2>제65조의2 (벌칙) 다음 각호의 1에 해당하는 자는 1천만원 이하의 벌금에 처한다.</h2>
        <div class="terms-conditions">
          ① 제50조제4항의 규정을 위반하여 기술적 조치를 한 자<br>
          ② 제50조제6항의 규정을 위반하여 영리목적의 광고성 정보를 전송한 자<br>
          ③ 제50조의2의 규정을 위반하여 전자우편주소를 수집·판매·유통 또는 정보전송에 이용한 자
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EtcUnauthorizedCollection.vue